import { file, prop, required, date } from '@rxweb/reactive-form-validators';

export class ExportMediaReportModel {

	@date({allowISODate: true})
	start: string;

	@date({allowISODate: true})
	end: string;

	@required()
	groups_id: string[];
}
